module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_55-88c8b7a01a246fc5a18202c188aa39d4.png";